import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconCaretDown: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width={$size} height={$size} viewBox="0 0 18 18" fill="none">
      <path
        d="M15.1455 6.53203C15.1024 6.42966 15.03 6.34231 14.9375 6.281C14.8449 6.21969 14.7362 6.18716 14.6251 6.1875H3.37514C3.26409 6.18716 3.15542 6.21969 3.06283 6.281C2.97023 6.34231 2.89786 6.42966 2.85483 6.53203C2.8143 6.63593 2.80402 6.74918 2.82517 6.85868C2.84633 6.96818 2.89805 7.06945 2.97436 7.15078L8.59936 12.7758C8.70688 12.8797 8.85058 12.9379 9.00014 12.9379C9.1497 12.9379 9.29341 12.8797 9.40092 12.7758L15.0259 7.15078C15.1022 7.06945 15.154 6.96818 15.1751 6.85868C15.1963 6.74918 15.186 6.63593 15.1455 6.53203Z"
        fill={rest?.$color}
      />
    </svg>
  </IconStyled>
);

IconCaretDown.defaultProps = iconDefaultProps;
IconCaretDown.displayName = 'IconCaretDown';

export default IconCaretDown;
